export const MONITOR_ADD_SORT_COLUMNS: any = {
  acr: 'acr_num',
  cqs_trend_1y: 'cqs_trend_1y_num',
  cqs_trend_3y: 'cqs_trend_3y_num',
  cqs_volatility: 'cqs_volatility_num',
  credit_risk_level: 'credit_risk_level_num',
  credit_risk_trend_1y: 'credit_risk_trend_1y_num',
  credit_risk_trend_6m: 'credit_risk_trend_6m_num',
  cqs_outlook: 'cqs_outlook_num',
};
